
export default {
  name: "PublicHeader",
  props: {
    gtUrl: String,
    organizationName: String,
    showDTLogo: Boolean,
  },
};
